import AbstractAPI from '@/services/api/AbstractAPI';

export default class CoverageRegionApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/coverage-region');
  }

  find(needle) {
    return this.makeRequest('/', 'get', {params:{search:needle}});
  }
}
